import React, { Component } from "react";
import { Link } from "react-router-dom";
import { invokeApig } from '../../libs/awsLib';
import { ProgressBar, Glyphicon, Button, Modal, Row, Col } from "react-bootstrap";
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import '../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import FleetDatePicker from '../../components/FleetDatePicker';
import CompareUnits from './CompareUnits';

export default class ListTrip extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            trips: [],
            compareDisabled: true,
            showCompare: false,
            unitsSelected: []
        };
    }
    componentDidMount() {
        this.updateTrips({});
    }

    async updateTrips(dates) {
    	try {
        	const results = await this.trips(dates);
        	this.setState({ trips: results, isLoading: false });
        } catch (e) {
        	alert(e);
        	this.setState({ isLoading: false });
        }
    }
    
    trips(dates) {
        return invokeApig({
            path: "/trip/summary",
            method: "POST",
            body: {
                "page": 0,
                "size": 10,
                "startDate": dates.startDate,
                "endDate": dates.endDate
            }
        });
    }
    selectBarColor(value) {
    	if (value < 35) return 'danger';
    	if (value < 70) return 'warning';
    	return 'success';
    }
    onRowSelect = (row, isSelected, e) => {
    	const selected = [];
    	if (isSelected) { //agregar
    		this.state.unitsSelected.map((unit) => {
    		  selected.push(unit);
    		  return unit;
    		});
    		selected.push(row.unitName);
    	} else { //eliminar
    		this.state.unitsSelected.map((unit) => {
			  if (row.unitName !== unit) {
				selected.push(unit);
			  }
    		  return unit;
    		});
    	}
    	this.setState({ unitsSelected: selected, compareDisabled: selected.length < 2 });
	}
    scoreFormatter = (cell, row) => {
      return <ProgressBar now={cell} label={ cell + '%' } bsStyle={this.selectBarColor(cell)} />
    }
    unitFormatter = (cell, row) => {
      return <Link to="/trips/detail">{cell}</Link>;
    }
    setTableOption() {
    	if (this.state.isLoading) {
    	  return <div><Glyphicon glyph="refresh" className="spinning" />Cargando datos... por favor espere</div>;
	    } else {
	      return "No hay datos";
	    }
    }
    handleShowCompare = (event) => {
	  this.setState({ showCompare: true });
    }
    handleCloseCompare = (event) => {
      this.setState({ showCompare: false });
    }
    handleDatesSelec = (dates) => {
      this.updateTrips(dates);
    }
    renderModal () {
      return (
		<Modal show={this.state.showCompare} onHide={this.handleCloseCompare} dialogClassName="modal-compare">
          <Modal.Header closeButton>
            <Modal.Title>Comparación de vehículos</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          	<CompareUnits {...this.props} units={this.state.unitsSelected} />
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleCloseCompare}>Cerrar</Button>
          </Modal.Footer>
        </Modal>
      );
    }
    render(){
        const selectRowProp = {
		  mode: 'checkbox',
		  bgColor: 'pink', // you should give a bgcolor, otherwise, you can't regonize which row has been selected
		  hideSelectColumn: true,  // enable hide selection column.
		  clickToSelect: true,  // you should enable clickToSelect, otherwise, you can't select column.
		  onSelect: this.onRowSelect
		};
        const tableOptions = {
            noDataText: this.setTableOption()
        };
        const data = this.state.trips;
        return(
          <div>
            <Row>
        	  <Col sm={8}><FleetDatePicker onSelect={this.handleDatesSelec} className='datePicker'/></Col>
        	  <Col sm={4}><Button disabled={this.state.compareDisabled} onClick={this.handleShowCompare} className='btnCompare'>Comparar</Button></Col>
        	</Row>
        	{ this.renderModal() }
        	<BootstrapTable data={ data } selectRow={ selectRowProp } options={tableOptions} className='trips'>
                <TableHeaderColumn dataField='unitName' dataFormat={ this.unitFormatter } isKey columnClassName='tripLink'>Vehículo</TableHeaderColumn>
                <TableHeaderColumn dataField='unitType'>Tipo</TableHeaderColumn>
                <TableHeaderColumn dataField='distance' dataAlign='right'>Distancia</TableHeaderColumn>
                <TableHeaderColumn dataField='duration' dataAlign='right'>Duración</TableHeaderColumn>
                <TableHeaderColumn dataField='avgDistance' dataAlign='right'>Prom. Distancia</TableHeaderColumn>
                <TableHeaderColumn dataField='avgSpeed' dataAlign='right'>Prom. Velocidad</TableHeaderColumn>
                <TableHeaderColumn dataField='safetyScore' dataFormat={ this.scoreFormatter }>Puntaje Seg</TableHeaderColumn>
                <TableHeaderColumn dataField='ecoScore' dataFormat={ this.scoreFormatter }>Puntaje Eco</TableHeaderColumn>
            </BootstrapTable>
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/trip/ListTrip.js